import { render } from "./AdminPlans.vue?vue&type=template&id=d3f4ded4&scoped=true"
import script from "./AdminPlans.vue?vue&type=script&lang=js"
export * from "./AdminPlans.vue?vue&type=script&lang=js"

import "./AdminPlans.vue?vue&type=style&index=0&id=d3f4ded4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3f4ded4"]])

export default __exports__